export default class ShapeGenerator {
    public static buildGrid(length: number, width: number, color: number = 0x000000, center: THREE.Vector3 = new THREE.Vector3(0, 0, 0), normal: THREE.Vector3 = new THREE.Vector3(0, 1, 0)) {
        const grid = new THREE.Object3D();

        for (let i = 0; i <= length; i++) {
            grid.add(ShapeGenerator.createLine(new THREE.Vector3(-width / 2, 0, -length / 2 + i), new THREE.Vector3(+width / 2, 0, -length / 2 + i), color, false));
        }
        for (let i = 0; i <= width; i++) {
            grid.add(ShapeGenerator.createLine(new THREE.Vector3(-width / 2 + i, 0, -length / 2), new THREE.Vector3(-width / 2 + i, 0, +length / 2), color, false));
        }

        grid.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), normal.clone().normalize());
        grid.position.copy(center);
        return grid;
    }

    private static createLine(src, dst, colorHex, dashed) {
        var geom = new THREE.Geometry();

        var mat;
        if (dashed) {
            mat = new THREE.LineDashedMaterial({ color: colorHex, dashSize: dst.length() / 10, gapSize: dst.length() / 10 });
        } else {
            mat = new THREE.LineBasicMaterial({ color: colorHex });
        }

        geom.vertices.push(src.clone());
        geom.vertices.push(dst.clone());
        geom.computeLineDistances(); // otherwise dashed lines will appear as simple plain lines

        return new THREE.Line(geom, mat, THREE.LinePieces);
    }
}